// src/components/SocialActionsCard.js
import React from 'react';
import './SocialActionsCard.css';
// Assuming Font Awesome is already linked in index.html for icons

function SocialActionsCard() {
  return (
    <div className="info-card social-actions-card">
      <h3 className="info-card-title">
        <i className="fas fa-bullhorn"></i> Get FREE Perks!
      </h3>
      <div className="social-action-item">
        <h4>
          <i className="fab fa-instagram"></i> Instagram Check-in & Tag!
        </h4>
        <p>
          Check in at <strong>Brady's Neighborhood Bar</strong> on Instagram and tag
          <a
            href="https://www.instagram.com/Ballz_deep_at_bradysSRQ" // Replace with actual link
            target="_blank"
            rel="noopener noreferrer"
            className="social-link"
          > @Ballz_deep_at_bradysSRQ
          </a> in your story or post during Bingo!
        </p>
      </div>
      <div className="social-action-item">
        <h4>
          <i className="fab fa-facebook-square"></i> Facebook Tag!
        </h4>
        <p>
          Tag <strong>Brady's Neighborhood Bar</strong> on Facebook in your Bingo night post!
        </p>
      </div>
      <div className="social-reward">
        <p>
          Show us your tag/check-in at next week's event to receive:
        </p>
        <ul>
          <li><i className="fas fa-check-circle"></i> First 4 Bingo Cards FREE!</li>
          <li><i className="fas fa-cocktail"></i> PLUS a FREE Jello Shot!</li>
        </ul>
      </div>
    </div>
  );
}

export default SocialActionsCard;
